/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespContentModuleCreator_browseContentModule = {
    readonly description: string | null;
    readonly title: string | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedStorefrontCreatorLink_browseContentModule">;
    readonly " $refType": "SbRespContentModuleCreator_browseContentModule";
};
export type SbRespContentModuleCreator_browseContentModule$data = SbRespContentModuleCreator_browseContentModule;
export type SbRespContentModuleCreator_browseContentModule$key = {
    readonly " $data"?: SbRespContentModuleCreator_browseContentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespContentModuleCreator_browseContentModule">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespContentModuleCreator_browseContentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedStorefrontCreatorLink_browseContentModule"
    }
  ],
  "type": "ContentModuleCreator",
  "abstractKey": null
};
(node as any).hash = 'c470c3db925ae203b1bf060037ce7c12';
export default node;
